<template>
  <div
    ref="headerRef"
    class="header-app"
  >
    <app-navigation
      v-if="!currentConfig.isBottomNavigationEnabled"
      @show-menu="$emit('show-menu')"
      @select-language="$emit('select-language', $event)"
      @restart-flow="$emit('restart-flow')"
      @navigate-button="$emit('navigate-button', $event)"
    />
    <div v-else />
    <close-website-button v-if="isWebsite && !isNotFullsizeWebsite && !currentConfig.isBottomNavigationEnabled" />
    <img
      v-else-if="companyLogo"
      :src="companyLogo"
      alt="company logo"
      class="logo-mini"
      @click="$emit('show-menu')"
    >
    <img
      v-else
      src="@/assets/plural_logo_mini.svg"
      alt="logo"
      class="logo-mini plural"
      @click="$emit('show-menu')"
    >
  </div>
</template>

<script>
import {
  computed,
  defineComponent,
  ref,
} from 'vue';
import useContent from '@/composables/useContent';
import useConfig from '@/composables/useConfig';
import useWebsite from '@/composables/useWebsite';
import usePullDown from '@/composables/usePullDown';
import CloseWebsiteButton from '@/components/CloseWebsiteButton.vue';
import AppNavigation from '@/components/AppNavigation.vue';

export default defineComponent({
  name: 'AppHeaderComponent',

  emits: ['show-menu', 'restart-flow', 'select-language', 'navigate-button'],

  components: {
    CloseWebsiteButton,
    AppNavigation,
  },

  setup() {
    const { findContentAssetUrl } = useContent();
    const {
      currentConfig,
      initialConfig,
    } = useConfig();
    const { isWebsite, isNotFullsizeWebsite } = useWebsite();
    const companyLogo = computed(() => {
      const currentLogo = findContentAssetUrl(currentConfig.value.companyLogo);
      if (currentLogo) return currentLogo;

      const mainLogo = findContentAssetUrl(initialConfig.value.companyLogo, { useMain: true });
      if (mainLogo) return mainLogo;

      return findContentAssetUrl(initialConfig.value.companyLogo);
    });

    const headerRef = ref(null);
    usePullDown(headerRef);

    return {
      isWebsite,
      isNotFullsizeWebsite,
      companyLogo,
      currentConfig,
      headerRef,
    };
  },
});
</script>

<style lang="scss" scoped>
.header-app {
  padding: 10px 16px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 4;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;

  @media screen and (max-height: $mobile_height_breakpoint) {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    height: 188px;
    padding: 20px 40px;
    position: static;
  }
}
.logo-mini {
  max-width: 160px;
  max-height: 32px;
  cursor: pointer;
  position: relative;
  z-index: 10000;

  &.plural {
    max-height: 24px;

    @media screen and (min-width: $tablet_breakpoint) {
      max-height: 32px;
    }

    @media screen and (max-height: $mobile_height_breakpoint) {
      max-height: 24px;
    }
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    transform: scale(3);
    transform-origin: center right;
  }
}
</style>
